import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

import { RolDetailFormInput } from '../entity-roles/roles.model';

@Component({
  selector: 'rpe-rol-detail',
  templateUrl: './rol-detail.component.html',
  styleUrls: ['./rol-detail.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RolDetailComponent implements OnInit {
  @Input()
  set formInput(rolDetailFormInput: RolDetailFormInput) {
    this._formInput = rolDetailFormInput;
    // console.log(rolDetailFormInput, 'RolDetail');
    if (rolDetailFormInput != null) {
      this.persona_jurica_denominacion_social =
        rolDetailFormInput.persona_jurica_denominacion_social;
      this.persona_juridica_nombre_fantasia =
        rolDetailFormInput.persona_juridica_nombre_fantasia;
      this.persona_juridica_rut = rolDetailFormInput.persona_juridica_rut;
      this.rol_tipo_rol_id_nombre = rolDetailFormInput.rol_tipo_rol_id_nombre;
      this.persona_nombre_completo = rolDetailFormInput.persona_nombre_completo;
      this.persona_documento_persona_numero =
        rolDetailFormInput.persona_documento_persona_numero;
      this.esPersona = rolDetailFormInput.esPersona;
    }
  }
  get formInput(): RolDetailFormInput {
    return this._formInput;
  }

  _formInput: RolDetailFormInput = null;

  persona_jurica_denominacion_social: string;
  persona_juridica_nombre_fantasia: string;
  persona_juridica_rut: string;
  rol_tipo_rol_id_nombre: string;
  persona_nombre_completo: string;
  persona_documento_persona_numero: number;
  esPersona: boolean;

  constructor() {}

  ngOnInit() {}

  save() {}

  onSubmit() {}

  onCancel() {}
}
